import _main from "./lib/main";
export { _main as default };
export const InterpolateOption = _main.InterpolateOption,
  Interpolation = _main.Interpolation,
  interpolation = _main.interpolation;